import api from "../Services/Api";
import {observable} from "mobx";

class XmlGenerationDebugStore {
    @observable visible: boolean = false;
    @observable userId: string = '';

    async show() {
        this.visible = true;
    }

    hide() {
        this.userId = '';
        this.visible = false;
    }

    get canCreate() {
        return !!this.userId;
    }

    async create() {
        if (!this.canCreate) {
            return;
        }
        
        const result = await api.post('admin/xmlGenerationDebug.createJob', {
            userId: this.userId
        });
        if (result.success) {
            this.hide();
        }
    }
    
    setUserId(userId: string) {
        this.userId = userId;
    }
}

const xmlGenerationDebugStore = new XmlGenerationDebugStore();
export default xmlGenerationDebugStore;